<template>
  <div>
    <div @click="get_adv_show()">
        <b-carousel
          id="ext-home-adv"
          v-model="slide"
          :interval="5000"
          controls
          background="#ffffff"
          img-width="1000"
          img-height="400"
          label-prev=""
          label-next=""
          style="text-shadow: 1px 1px 2px #333;"
        >
            <b-carousel-slide v-for="(vo,index) in list" :key="index" class="ext-adv-img" img-width="1000" img-height="400" :img-src="web_url+vo.image"></b-carousel-slide>
            <ol class="ext-adv-indicators">
                <li v-for="(vo,index) in list" :key="index" @click="set_index(index)" :class="[slide==index ? 'active' : '']"></li>
            </ol>
        </b-carousel>
    </div>

  </div>
</template>

<script>
import {getUserId, ajax, webUrl, Encrypt} from '@/utils/extend'
export default {
  name: 'ExtAdv',
  data () {
    return {
      web_url: webUrl(),
      slide: 0,
      sliding: null,
      list: []
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    set_index (index) {
      this.slide = index
    },
    get_adv_show () {
      var index = this.slide
      var classId = this.list[index].class_id
      var url = this.list[index].url

      if (classId === '17' && url) {
        this.$router.push({path: '/activity/activity_show', query: {v: Encrypt(url)}})
      } else if (classId === '18' && url) {
        this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(url)}})
      } else if (classId === '40' && url) {

      }
    },
    load_data () {
      var that = this
      that.list = []
      ajax({
        url: '/store/home/home_adv_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.list = ret.data
        } else {
          that.list = []
        }
      })
    }
  }
}
</script>
<style>
#ext-home-adv img { width:1000px !important; height: 400px !important;}

.carousel-control-prev-icon, .carousel-control-next-icon { width:3rem !important; height:3rem !important;}

.ext-adv-indicators { width:700px; height:5px; position: absolute; left:150px; bottom:5px;flex-flow:row; justify-content:center; display:-moz-box;display: box;display: -webkit-box;}
    .ext-adv-indicators li { width:50px; height:5px; cursor: pointer; background: #ffffff; opacity: 0.5; margin:0px 5px; display: block;}
    .ext-adv-indicators li.active { background: #d81e06; opacity: 1;}
    .ext-adv-img { cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/components/carousel/index.vue